import {Form} from '@kit/inputs/form';
import {Input} from '@kit/inputs/input/input.formik';
import {Password} from '@kit/inputs/password/password.formik';
import {Button, Loader} from '@kit';
import {Checkbox} from '@kit/inputs/checkbox/checkbox.formik';

import React, {useState} from 'react';
import {FormikProvider, useFormik} from 'formik';

import {useLoginMutation, User} from '../../generated/types';
import {useUser} from '../use-user';
import {getError} from '../utils';
import {OAuthButtons, PasskeyLoginButton, useAutoPasskeyLogin} from '../social-login';
import {Link} from '../../lib/routes';

import css from './login-form.module.css';

type Props = {
	onSuccess?: () => void;
};

type Values = {
	email: string;
	password: string;
	remember: boolean;
};

export const LoginForm: React.FC<Props> = ({onSuccess}) => {
	const [login, {loading}] = useLoginMutation();
	const [error, setError] = useState<any>();
	const {setUser} = useUser();
	const passkey = useAutoPasskeyLogin({onSuccess, onError: (message) => setError(new Error(message))});
	const formikBag = useFormik<Values>({
		initialValues: {
			email: '',
			password: '',
			remember: true,
		},
		onSubmit: (values, {setSubmitting}) => {
			login({variables: values})
				.then((result) => {
					if (result?.data?.login) {
						setUser(result.data.login as User);
						if (onSuccess) onSuccess();
					} else {
						setError(result.error);
						setSubmitting(false);
					}
				})
				.catch((error) => {
					setError(error);
					setSubmitting(false);
				});
		},
	});

	return (
		<div className={css.formWrapper}>
			<div className={css.wrapper}>
				{loading && <Loader withoutLoadingWrapper />}
				<FormikProvider value={formikBag}>
					<div className={css.error}>{getError(error)?.message}</div>
					<Form>
						<div className={css.field}>
							<Input name="email" label="E-mail" autoComplete="username webauthn" />
						</div>
						<div className={css.field}>
							<Password name="password" label="Пароль" autoComplete={'off'} />
						</div>
						<div className={css.button}>
							<Checkbox name={'remember'} label={'Запомнить?'} />

							<Button
								type={'submit'}
								appearance="primary"
								className={css.submit}
								disabled={formikBag.isSubmitting}
							>
								Войти
							</Button>
						</div>
					</Form>
					<div className={css.forget}>
						<Link route="forgotPassword" keepQuery={false} onClick={onSuccess}>
							Забыли пароль?
						</Link>
					</div>
					<div className={css.social}>
						{passkey.supported && <PasskeyLoginButton loading={passkey.loading} onClick={() => passkey.login(false)} />}
						<OAuthButtons action="Войти через" onError={(message) => setError(new Error(message))} />
					</div>
				</FormikProvider>
			</div>
		</div>
	);
};
